<template>
  <div>
    <div v-for="(p,index) in guids"
         :key="index">
      <div class="tit-index">
        <p class="line-tit-index"></p>
        <p class="node-tit-index">{{p.title}}</p>
      </div>
      <div class="layout-office">
        <div class="ele-office"
             v-for="(f,findex) in p.func"
             :key="findex">
          <div v-for="(s,sindex) in f"
               :key='sindex'><img :src="s.url"
                 @click="toPage(s.routePath,s.name)">
            <div v-if="s.note"
                 v-show="approveCount>0"
                 class="icon-note-office">{{approveCount}}</div>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import approveModel from '../../api/model/approve'
import { mapState } from 'vuex'
export default {
  name: 'demo',
  components: {},
  data() {
    return {
      //这里的数据后期可能调整为从API获取
      guids: [
        {
          title: '个人办公',
          func: [
            //第一列
            [
              {
                name: 'approveFunc',
                note: true,
                url: require(`@/assets/images/img-check-index.png`),
                routePath: '/approve',
              },
              {
                name: 'customerFunc',
                note: false,
                url: require(`@/assets/images/img-adduser-index.png`),
                routePath: '/customer/0/0',
              },
              {
                name: 'clueFunc',
                note: false,
                url: require(`@/assets/images/img-clue-index .png`),
                routePath: '/clue',
              },
            ],
            //第二列
            [
              {
                name: 'createReportFunc',
                note: false,
                url: require(`@/assets/images/img-addvisite-index.png`),
                routePath: '/createReport',
              },
              {
                name: 'signCheckFunc',
                note: false,
                url: require(`@/assets/images/img-attendances-index.png`),
                routePath: '/signCheck',
              },
              {
                name:'visitPlanFunc',
                note:false,
                url: require(`@/assets/images/img-plan-index.png`),
                routePath:'/visitPlan'
              }
            ],
          ],
        },
      ],
      approveCount: '0',
    }
  },
  methods: {
    toPage(routePath, funcName) {
      if (routePath == '#') {
        this.$toast('很抱歉，该功能暂未开放')
      } else {
        if (
          funcName == 'approveFunc' &&
          this.userRole == this.RoleType.salesman
        ) {
          this.$toast('很抱歉，您没有权限使用该功能模块')
          return
        }
        this.$router.push({ path: routePath })
      }
    },
    async getDataByType(type) {
      this.type = type
      const res = await approveModel.getApproveCount()
      if (res != undefined) {
        if (res.success) {
          if (res.data > 99) {
            this.approveCount = '99+'
          } else {
            this.approveCount = res.data
          }
          if (res.data > 0) {
            this.$dialog
              .alert({
                message:
                  '亲爱的' + this.salesName + ',您有待审批的信息，请尽快处理',
              })
              .then(() => {
                // on close
              })
          }
        } else {
          this.$toast(res.msg)
        }
      }
    },
  },
  computed: {
    ...mapState('systemAbout', ['RoleType']),
    ...mapState('userAbout', ['salesName', 'userRole']),
  },
  mounted() {
    this.getDataByType()
  },
}
</script>

<style scoped>
</style>